import {createAction} from '@reduxjs/toolkit'
import {OverviewViolationsState, OverviewAnalyticsState} from 'interfaces'

// overview violations actions
export const getOverviewViolations = createAction('getOverviewViolations')
export const getOverviewViolationsSuccess =
  createAction<OverviewViolationsState>('getOverviewViolationsSuccess')
export const getOverviewViolationsFailure = createAction<string>(
  'getOverviewViolationsFailure',
)

// overview analytics actions
export const getOverviewAnalytics = createAction('getOverviewAnalytics')
export const getOverviewAnalyticsSuccess = createAction<OverviewAnalyticsState>(
  'getOverviewAnalyticsSuccess',
)
export const getOverviewAnalyticsFailure = createAction<string>(
  'getOverviewAnalyticsFailure',
)
